var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmznIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FB9908;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.7,532.4H78.1l63.4-183.5h50l63.3,183.5h-41.6l-46-141.6h-1.4L119.7,532.4z M117.1,460.2h98.2v30.3h-98.2 V460.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M267.7,348.8h47.9l50.5,123.3h2.2l50.5-123.3h47.9v183.5H429V412.9h-1.5L380,531.5h-25.6l-47.5-119h-1.5v119.9 h-37.6V348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M487.5,532.4v-23l91.6-128.5h-91.8v-32h140.5v23l-91.7,128.5H628v32H487.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M802.2,348.8v183.5h-33.5l-79.8-115.5h-1.3v115.5h-38.8V348.8h34.1L762,464.3h1.6V348.8H802.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmznIcon);
export default __webpack_public_path__ + "static/media/amzn_icon.fb3bb4365218b7ec29e5f35c95fad3c2.svg";
export { ForwardRef as ReactComponent };